import './App.css';
import {useEffect, useState} from "react";
import { ethers } from "ethers";
import zapportal from './utils/ZapPortal.json';
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
import ReactTimeAgo from 'react-time-ago'

function App() {
  const [currentAccount, setCurrentAccount] = useState("");
  const [connected, setConnected] = useState(false);
  const [allZaps, setAllZaps] = useState([]);
  const contractAddress = '0x999C9893C616700D7C47e7015fbE4D2c5eFC8e50';
  const [mining, setMining] = useState(false);

  TimeAgo.addDefaultLocale(en);

  const checkAuth = async () => {
    try {
      const { ethereum } = window;

      if (!ethereum) {
        setConnected(false);
        return;
      } else {
        setConnected(true);
      }

      const accounts = await ethereum.request({method: 'eth_accounts'});

      if (accounts.length > 0) {
        console.log("Found an authorized account:", accounts[0]);
        setCurrentAccount(accounts[0]);
      } else {
        console.log('No authorized account found');
      }
    } catch (e) {
      console.log(e);
    }
  }

  const connectWallet = async () => {
    try {
      const { ethereum } = window;

      if (!ethereum) {
        alert('No metamask');
        return;
      }

      const accounts = ethereum.request({ method: 'eth_requestAccounts' });
      console.log('Connected', accounts[0]);
      setCurrentAccount(accounts[0]);

    } catch (e) {
      console.log(e);
    }
  }

  const zap = async () => {
    if (mining) {
      return;
    }

    try {
      const { ethereum } = window;

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(contractAddress, zapportal.abi, signer);

        const txn = await contract.zap(prompt("Your message"))
        setMining(true);
        console.log('Mining', txn.hash);

        await txn.wait();
        console.log('Mined', txn.hash);
        setMining(false);

        await getAllZaps();
      } else {
        console.log('ETH does not exist');
      }
    } catch (e) {
      console.log(e);
    }
  }

  const getAllZaps = async () => {
    try {
      const { ethereum } = window;

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(contractAddress, zapportal.abi, signer);

        const zaps = await contract.getAllZaps();

        let zapsCleaned = [];
        zaps.forEach(zap => {
          zapsCleaned.push({
            address: zap.zapper,
            timestamp: new Date(zap.timestamp * 1000),
            message: zap.message
          });
        });

        zapsCleaned = zapsCleaned.reverse();

        setAllZaps(zapsCleaned);
      }
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    checkAuth();
    getAllZaps();
  }, [])

  return (
    <div className="App flex h-screen bg-white">
      <div className="relative overflow-hidden m-auto">
        <div className="relative pt-6 pb-16 sm:pb-24">
          <main className="mt-16 mx-auto max-w-7xl px-4 sm:mt-24">
            <div className="text-center">
              <p className="mt-3 max-w-md mx-auto text-base text-gray-900 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
                Hey folks 👋🏼,<br/><br/>
                I'm <a href="https://twitter.com/heydarmen" target="_blank" rel="noreferrer" className="text-twitter-blue underline">Darmen</a>, and this is my first Web3 application so far.
                <br/>
                Click the button bellow to make some dope zaps!
              </p>

              <div className="mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8">
                <div className="">
                  <button type="button" className={`${mining ? 'block' : 'hidden'} w-full flex items-center justify-center tracking-tight font-extrabold px-8 py-6 text-6xl font-medium bg-white border border-gray-400 shadow-offset-grey`}>
                    <span className="block text-gray-400 xl:inline">
                      mining...
                    </span>
                  </button>

                  <button type="button" onClick={connectWallet} className={`${!currentAccount ? 'block' : 'hidden'} w-full flex items-center justify-center tracking-tight font-extrabold px-8 py-6 text-6xl font-medium bg-white border border-green-400 shadow-offset-green`}>
                    <span className="block text-green-400 xl:inline">
                      authenticate wallet
                    </span>
                  </button>

                  <button type="button" onClick={zap} className={`${!mining && currentAccount ? 'block' : 'hidden'} w-full flex items-center justify-center tracking-tight font-extrabold px-8 py-6 text-6xl font-medium bg-white shadow-offset-red border border-red-original hover:bg-yellow-100 cursor-pointer transition duration-100 hover:shadow-offset-red-more`}>
                    <span className="block text-red-original xl:inline">
                      zzap!
                    </span>
                  </button>
                </div>
              </div>

              <div className="mt-4">
                <span className="relative inline-flex">
                  <span className={`inline-flex items-center px-4 py-2 text-base font-light ${connected ? 'text-green-500' : 'text-gray-500'} transition ease-in-out duration-150`}>
                    {connected && 'Connected to Ethereum'}
                    {!connected && 'Not connected to Ethereum'}.
                  </span>
                  <span className="flex absolute h-3 w-3 inset-y-1/2 -left-1 -mt-1.5 justify-center">
                    <span className={`${connected ? 'animate-ping' : ''} absolute inline-flex h-full w-full rounded-full bg-purple-400 opacity-75`}></span>
                    <span className={`relative inline-flex rounded-full h-3 w-3 ${connected ? 'bg-green-500' : 'bg-gray-500'}`}></span>
                  </span>
                </span>
              </div>

              <div className="mt-4 mb-4">
                <div className="flow-root">
                  <ul className="-mb-8">
                    {allZaps.map((zap, idx) => (
                        <li key={idx}>
                          <div className="relative pb-2">
                            <div className="relative flex space-x-3">
                              <div>
                                <span className={'h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white'}>
                                  ⚡️
                                </span>
                              </div>
                              <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                                <div>
                                  <p className="text-sm text-gray-500">
                                    {zap.message}
                                  </p>
                                </div>
                                <div className="text-right text-sm whitespace-nowrap text-gray-500">
                                  <time>
                                    <ReactTimeAgo date={zap.timestamp} locale="en-US"/>
                                  </time>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="mt-10">
                <div className="inline-flex items-center">
                  <a href="https://twitter.com/heydarmen" target="_blank" rel="noreferrer"
                     className="inline-flex items-center text-twitter-blue hover:text-opacity-90">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor"
                         className="inline-block h-5 w-5 mr-1 ml-1" viewBox="0 0 16 16">
                      <path
                          d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z"/>
                    </svg>
                    Follow me on Twitter
                  </a>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default App;
